import { inject, provide, ssrRef, toRef, useContext } from '@nuxtjs/composition-api';
import { useDialog } from '~/composables/useModal';

export const notificationStoreKey = Symbol('notificationStore');

export function installNotificationContext() {
  /**
   * Notification State
   */
  const state = ssrRef(() => ({
    notifications: [],
    headerNotifications: [],
    notificationsPagination: {},
    notificationCount: 0,
  }));

  const { $service } = useContext();
  const { openErrorDialog } = useDialog();

  async function getNotifications({ page, limit, isHeader = false } = {}) {
    try {
      const { data, pagination: paginationData } = await $service.notification.getNotificationList({ page, limit });
      if (isHeader) {
        state.value.headerNotifications = data;
      } else {
        state.value.notifications = page ? state.value.notifications.concat(data) : data;
      }
      // okundu bilgisi
      const ids = [];
      data.map((item) => {
        if (item.status !== 'seen') {
          ids.push(item._id);
        }
      });
      if (ids.length > 0) {
        const params = { notifications: ids };
        await $service.notification.updateNotificationStatus(params);
        state.value.notificationCount -= data.length;
      }

      state.value.notificationsPagination = paginationData;
    } catch (error) {
      openErrorDialog({ error });
    }
  }

  function resetNotifications() {
    state.value.notifications = [];
    state.value.notificationsPagination = {};
  }

  async function getNotificationCount() {
    try {
      const { data } = await $service.notification.getNotificationCount();
      state.value.notificationCount = data;
    } catch (error) {}
  }

  async function markAllNotificationAsRead() {
    const params = { all: true };
    await $service.notification.updateNotificationStatus(params);
    state.value.notificationCount = 0;
  }

  provide(notificationStoreKey, {
    state,
    notifications: toRef(state.value, 'notifications'),
    headerNotifications: toRef(state.value, 'headerNotifications'),
    notificationsPagination: toRef(state.value, 'notificationsPagination'),
    notificationCount: toRef(state.value, 'notificationCount'),
    markAllNotificationAsRead,
    resetNotifications,
    getNotifications,
    getNotificationCount,
  });
}

/**
 * @typedef {Object} Notification
 * @property {import("@nuxtjs/composition-api").Ref.<number>} notificationCount
 * @property {import("@nuxtjs/composition-api").Ref.<array>} notifications
 * @property {import("@nuxtjs/composition-api").Ref.<array>} headerNotifications
 * @property {import("@nuxtjs/composition-api").Ref.<object>} notificationsPagination
 * @property {function} getNotifications
 * @property {function} getNotificationCount
 * @property {function} markAllNotificationAsRead
 * @property {function} resetNotifications
 */

/**
 * @returns {Notification} Notification State
 */
export function useNotification() {
  return inject(notificationStoreKey);
}
